import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";

import { LoggerService } from "@bfx/logger";
import { IPlatformProfileLookupService } from "shared/cubiq-services/lookup/model/IPlatformProfileLookupService";
const logger = LoggerService.for(__dirname);

@Injectable()
export class PlatformProfileLookupService
  extends BaseLookupService<string, CubiqTS.PlatformProfileImpl>
  implements IPlatformProfileLookupService
{
  constructor() {
    super(CubiqTS.PlatformProfileImpl);
  }

  mapItem(item: CubiqTS.PlatformProfileImpl): void {
    super.mapItem(item);
  }

  getItemKey(item: CubiqTS.PlatformProfileImpl): string {
    return String(item.profileId);
  }

  getPlatformProfile(id: string): CubiqTS.PlatformProfileImpl {
    const profile = this.getItem(id);
    return profile;
  }

  getAllPlatformProfiles(): Array<CubiqTS.PlatformProfileImpl> {
    return Array.from((<Map<CubiqTS.PlatformProfileImpl, any>>this.myItemMap).keys());
  }
}
